import React, { useState } from 'react';
import { Routes, Route, BrowserRouter as Router } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppThunkDispatch } from '../../interfaces/redux.interface';
import { authActions, selectUser } from '../../redux/authSlice';
import { IRoute } from '../../interfaces/router.interface';
import PrivateRoute from './PrivateRoute/PrivateRoute';
import PublicRoute from './PublicRoute/PublicRoute';
import useOnMount from '../../hooks/useOnMount';
import routes from '../routes';

const AppRouter = () => {
  const dispatch: AppThunkDispatch = useDispatch();
  const [authRequested, setAuthRequested] = useState(false);

  const user = useSelector(selectUser);

  useOnMount(() => {
    if (user) {
      dispatch(authActions.currentAuthenticatedUser())
        .then(() => {
          setAuthRequested(true);
        })
        .catch((error) => {
          console.error("Error fetching authenticated user:", error);
          setAuthRequested(true);
        });
    } else {
      setAuthRequested(true);
    }
  });  

  const buildRoute = (route: IRoute) => {
    const { path, public: isPublic, component: Component, admin, childRoutesElements } = route;
  
    if (isPublic) {
      return (
        <Route
          key={path}
          path={path}
          element={<PublicRoute component={Component} />}
        >
          {childRoutesElements}
        </Route>
      );
    }
  
    return (
      <Route
        key={path}
        path={path}
        element={<PrivateRoute component={Component} admin={admin} />}
      >
        {childRoutesElements}
      </Route>
    );
  };
  

  const buildRoutes = (routesArray: IRoute[]) =>
    routesArray.map((route) => {
      if (route.childRoutes) {
        route.childRoutesElements = buildRoutes(route.childRoutes);
      }
      return buildRoute(route);
    });

  if (!authRequested) return null;

  return (
    <Router>
      <Routes>{buildRoutes(routes)}</Routes>
    </Router>
  );
};

export default AppRouter;
